import React, { useState } from "react";
import data from "../data/navigationn.json";

const Sidebar = ({}) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSelectedSubCategory(null);
  };

  const [showfilters, setShowfilters] = useState(false);

  const [togglecatgeories, setTogglecategories] = useState({
    Index: -1,
    State: false,
  });

  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  const sorting = (name, index, type, subname) => {};

  const handleSubCategoryClick = (subCategory) => {
    setSelectedSubCategory(subCategory);
  };
  // console.log(data, "Svsfdvdfsvdfsvdfv")
  return (
    <div className="border-r min-h-[100vh]">
      {data?.map((category, index) => {
        return (
          <div className="flex flex-col gap-2 w-full z-50 mr-2" key={index}>
            <div
              className={`flex justify-between cursor-pointer border-t border-[#ededed] py-4 ${
                category.active == 1
                  ? "opacity-100 "
                  : "opacity-70 pointer-events-none"
              } ${category.display == 1 ? "block" : "hidden"}
                  `}
              onClick={(e) => {
                e.stopPropagation();
                setTogglecategories({
                  Index: index,
                  State:
                    category.categories.length !== 0 && !togglecatgeories.State,
                });
              }}
            >
              <p
                className={`text-[14px] leading-[24px]    ${
                  selectedSubcategory == category.name
                    ? "font-bold"
                    : "font-normal"
                }`}
                onClick={(e) => {
                  category.categories.length == 0 &&
                    sorting(category.name, index, "subCategories");
                }}
              >
                {category.name}
              </p>
              {category.categories?.length !== 0 && (
                <button type="button" className="">
                  <img
                    src="./assets/icons/dpd_arrow.png"
                    alt=""
                    className={`${
                      togglecatgeories.Index == index && togglecatgeories.State
                        ? "rotate-0"
                        : "rotate-180"
                    } transition-all duration-300 ease-in-out mx-2 `}
                    width={12}
                    height={8}
                  />
                </button>
              )}
            </div>
            {togglecatgeories.Index == index && togglecatgeories.State && (
              <div className="pb-4 " onClick={() => setShowfilters(false)}>
                {category.categories?.map((subcategory, index) => {
                  return (
                    <div key={index}>
                      <div
                        className={`flex gap-4 flex-nowrap   border-b cursor-pointer border-gray-600 py-2 md:py-0 md:border-none justify-start items-center w-full px-2 ${
                          subcategory.active == 1
                            ? "opacity-100 "
                            : "opacity-70 pointer-events-none"
                        } ${subcategory.display == 1 ? "block" : "hidden"} `}
                        onClick={(e) => {
                          sorting(
                            subcategory.name,
                            index,
                            "categories",
                            subcategory.name
                          );
                        }}
                        key={index}
                      >
                        <div
                          className={`min-w-[12px] max-w-[12px] h-[12px] border-black  border`}
                        >
                          <div
                            className={`w-full h-full rounded-sm ${
                              selectedSubcategory == subcategory.name
                                ? "bg-black border-[1px] "
                                : "bg-transparent"
                            }`}
                          ></div>
                        </div>

                        <p
                          className={`border-black font-[Karla] whitespace-nowrap leading-6 ${
                            selectedSubcategory == subcategory.name
                              ? "font-semibold"
                              : "font-normal"
                          }`}
                        >
                          {subcategory.name}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;
